import { AlertTriangle, ClipboardCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PendingChangesAlertProps {
  pendingChangesCount?: number;
  onReviewChanges: () => void;
}

export function PendingChangesAlert({
  pendingChangesCount,
  onReviewChanges,
}: PendingChangesAlertProps) {
  // Format the message based on whether count is provided
  const getMessage = () => {
    if (pendingChangesCount === undefined) {
      return 'Proposed changes pending review';
    }
    if (pendingChangesCount === 0) {
      return null;
    }
    return `${pendingChangesCount} proposed change${pendingChangesCount > 1 ? 's' : ''} pending review`;
  };

  const message = getMessage();
  if (!message) {
    return null;
  }

  return (
    <div
      className={cn(
        'text-orange-800 rounded-lg  flex items-center justify-between text-sm',
        'border border-orange-200 bg-orange-50 p-2 pl-4'
      )}
    >
      <div className="flex items-center">
        <AlertTriangle className="h-4 w-4 text-orange-800 mr-3 opacity-[0.55]" />
        <span className="whitespace-nowrap">{message}</span>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="ml-3 border-orange-300 text-orange-700 hover:bg-slate-100 hover:text-amber-800 hover:border-amber-400"
        onClick={onReviewChanges}
      >
        <ClipboardCheck className="h-4 w-4 mr-1 opacity-75" />
        Review Changes
      </Button>
    </div>
  );
}
